import { FrostFreeStatus, type Building } from "@eisox/api/core-api";
import { z } from "@eisox/zod";

import { DEFAULT_REDUCED_FROST_FREE_TEMPERATURE } from "~/constants/building.constant";
import {
  DEFAULT_START_FROST_FREE_AMB_SETPOINT,
  DEFAULT_START_FROST_FREE_SETPOINT,
  DEFAULT_TEMPORISATION_FROST_FREE_MODE,
} from "~/constants/season.constant";
import { TEMPERATURE_MAX, TEMPERATURE_MIN } from "~/constants/temperature.constant";
import { getDefaultMode, getDefaultPeriods, getFrostFreeModes, periodsSchema } from "~/features/frost-free";

export const updateHouseHollidaysSettingsSchema = z.object({
  mode: z.enum(FrostFreeStatus),
  frostFreePeriods: periodsSchema,
  frostFreeTemperature: z.number().min(TEMPERATURE_MIN).max(TEMPERATURE_MAX).optional(),
  setpointStartFrostFree: z.number().min(TEMPERATURE_MIN).max(TEMPERATURE_MAX).optional(),
  setpointStartFrostFreeAmb: z.number().min(TEMPERATURE_MIN).max(TEMPERATURE_MAX).optional(),
  temporisationFrostFreeMode: z.number().min(0).max(20).optional(),
  reducedFFTemperature: z.number().min(TEMPERATURE_MIN).max(100).optional(),
});

export type UpdateHouseHollidaysSettingsSchemaType = z.infer<typeof updateHouseHollidaysSettingsSchema>;

export const getDefaultValues = (
  house: Building,
  areFrostFreePeriodsAllowed: boolean,
): UpdateHouseHollidaysSettingsSchemaType => ({
  mode: getDefaultMode(house.frostFree.status, getFrostFreeModes({ periodsAllowed: areFrostFreePeriodsAllowed })),
  frostFreeTemperature: house.frostFreeTemperature,
  setpointStartFrostFree: house.setpointStartFrostFree ?? DEFAULT_START_FROST_FREE_SETPOINT,
  setpointStartFrostFreeAmb: house.setpointStartFrostFreeAmb ?? DEFAULT_START_FROST_FREE_AMB_SETPOINT,
  temporisationFrostFreeMode: house.temporisationFrostFreeMode ?? DEFAULT_TEMPORISATION_FROST_FREE_MODE,
  reducedFFTemperature: house.reducedFFTemperature ?? DEFAULT_REDUCED_FROST_FREE_TEMPERATURE,
  frostFreePeriods: getDefaultPeriods(house.frostFree.periods),
});
